import { Side } from "../types";
import { TextureType } from "./textures/textureSet";
import { Color4 } from "@babylonjs/core/Maths/math.color";

export const SIDES: Side[] = ['left', 'right'];
export const TEXTURE_TYPES: TextureType[] = ["emissive", "albedo", "normal", "metalRough"];

export const WHITE = new Color4(1, 1, 1, 1);
